import script from "./ResetPasswordView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts&setup=true"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=5d5e312b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5e312b"]])

export default __exports__